<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createTestbed()" *ngIf="!embeddedLayout && (!hasPermission(loggedUser, 'tester') || (hasPermission(loggedUser, 'admin') || hasPermission(loggedUser, 'customer')))" class="mb-1"
              color="primary" mat-button>New testbed
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortTestbeds($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
           matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{ element.id }}</td>
      </ng-container>

      <!-- Identifier Column -->
      <ng-container matColumnDef="identifier">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
        <td *matCellDef="let element" mat-cell> {{ element.identifier }}</td>
      </ng-container>

      <!-- Address Column -->
      <ng-container matColumnDef="address">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Address</th>
        <td *matCellDef="let element" mat-cell> {{ element.address }}</td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Company</th>
        <td *matCellDef="let element" mat-cell> {{ element.company?.companyName }}</td>
      </ng-container>


      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" class="text-right" mat-cell>
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">

            <span [matTooltip]="
            canIAccessTestbedFiles(element) ?
              !!element.storage ?
                'Show files' : 'This testbed has no associated storage!'
                : 'You cannot access this storage'">
              <button (click)="showFiles(element)" [disabled]="!element.storage || !canIAccessTestbedFiles(element)"
                      mat-icon-button>
                <mat-icon>folder</mat-icon>
              </button>
            </span>
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <ng-container *ngIf="element.weseth2 == true && contract != null">
              <button [routerLink]="['/reserved', 'contracts', contract.id, 'test-list']" [disabled]="disabled"
                      mat-icon-button matTooltip="Show test list">
                <mat-icon>input</mat-icon>
              </button>
              <button [disabled]="disabled" [routerLink]="['/reserved', 'contracts', contract.id, 'output-list']"
                      mat-icon-button matTooltip="Show output list">
                <mat-icon>list</mat-icon>
              </button>
              <ng-container *awIsInAnyRole="['customer', 'admin']">
                <button (click)="addTesters(element, contract)" [disabled]="disabled" mat-icon-button
                        matTooltip="Assign Tester">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </ng-container>
              <button (click)="expandTesters(element)" [disabled]="disabled" mat-icon-button matTooltip="Show Testers">
                <mat-icon>supervisor_account</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="!embeddedLayout">
              <button (click)="editTestbed(element)" [disabled]="disabled" mat-icon-button matTooltip="Edit testbed">
                <mat-icon>edit</mat-icon>
              </button>
              <ng-container *ngIf="!element.currentContract && hasPermission(loggedUser, 'admin')">

                <button (click)="deleteTestbed(element)" [disabled]="disabled" mat-icon-button
                        matTooltip="Delete testbed">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="expandedTestbed">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Files</h3>
            <button (click)="upload(element)" [disabled]="!selectedTestbedFiles" mat-button>
              <mat-icon>upload</mat-icon>
              Upload file
            </button>
            <button (click)="expandedTestbed = undefined; selectedTestbedFiles = undefined" mat-button>Close</button>
          </div>

          <aw-list-testbed-files (filesReady)="selectedTestbedFiles = $event"
                                 (requestClose)="expandedTestbed = undefined" [updateListOn]="upload$"
                                 *ngIf="expandedTestbed == element"
                                 [testbed]="element"></aw-list-testbed-files>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedTesters">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Testers</h3>
            <button (click)="expandedTesters = undefined" mat-button>Close</button>
          </div>
          <aw-list-users *ngIf="expandedTesters == element"
                         [embeddedLayout]="true" type="testersByTestbed"
                         [filterByTestbed]="element"
                         [deleteAction]="{enabled: true, action: deleteUserAction(element)}"
          ></aw-list-users>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matRowDef="let row; columns: ['expandedTestbed']" [fxShow]="expandedTestbed?.id === row.id" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedTesters']" [fxShow]="expandedTesters?.id === row.id" mat-row></tr>


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No testbeds found
        </td>
      </tr>

    </table>

  </ng-container>

  <mat-paginator #paginatorTestbeds [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
                 [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>
